<div [id]="htmlId()" class="section" [style.display]="isVisible() ? 'block' : 'none'">
  <div class="title">
    @if (properties.allowCollapse) {
      <picture class="icon" (click)="onToggleClick()">
        <img [src]="imageSrc()" alt="Toggle Section" width="128" height="128" />
      </picture>
    }
    <span [ngClass]="[properties.style.toLowerCase(), 'preserve-newlines']">{{ properties.text }}</span>
  </div>
</div>
